<template>
    <select class="form-control language w-auto" v-model="selected">
        <option v-for="lang in items" :value="lang.value">{{lang.name}}</option>
    </select>
</template>

<script>
    import storage, {LANGUAGE_REQUEST} from '../_store'
    import moment from 'moment'
    import eventBus from '../modules/eventBus'
    import i18n from '../i18n'

    export default {
        name: 'Language',
        data () {
            return {
                selected: null,
                items: [
                    {
                        name: 'Česky',
                        value: 'cs'
                    },
                    {
                        name: 'English',
                        value: 'en'
                    },
                    {
                        name: 'Ελληνικά',
                        value: 'el'
                    }
                ]
            }
        },
        watch: {
            selected (lang) {
                i18n.global.locale.value = lang
                moment.locale(lang)
                storage.dispatch(LANGUAGE_REQUEST, lang)
                eventBus.emit('language', lang)
            }
        },
        methods: {
            getLangugage () {
                return this.selected
            }
        },
        created () {
            this.selected = storage.getters.language
        }
    }
</script>

<style scoped>

</style>
